function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "BTN_plus",
  transform: "translate(-913 -440)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "HG",
  width: 34,
  height: 38,
  transform: "translate(913 440)",
  fill: "#fff",
  opacity: 0
}), /*#__PURE__*/React.createElement("line", {
  id: "Linie_37",
  "data-name": "Linie 37",
  y2: 19.799,
  transform: "translate(920.05 460) rotate(-90)",
  fill: "none",
  stroke: "#333330",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Linie_38",
  "data-name": "Linie 38",
  y2: 19.799,
  transform: "translate(929.949 450.101)",
  fill: "none",
  stroke: "#333330",
  strokeLinecap: "round",
  strokeWidth: 2
}));

function SvgBtnPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 38,
    viewBox: "0 0 34 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPlus);
export default __webpack_public_path__ + "static/media/BTN_plus.6a904c48b4b79721d1f16188a34eeca0.svg";
export { ForwardRef as ReactComponent };